app.controller(
    'SetCreationController', ['$scope', '$rootScope', '$state', '$stateParams', '$translate', '$sce', '$window', '$timeout', 'GroupService', 'HelperService', 'ExplorerService', SetCreationController]
);

function SetCreationController($scope, $rootScope, $state, $stateParams, $translate, $sce, $window, $timeout, GroupService, HelperService, ExplorerService) {
    var vm = this;
   
    vm.GroupVm = {};
    vm.ActiveDescriptionVm = {};
    vm.ActiveDescriptionIndex = 0;
    vm.NewDescriptionVm = {};
    $scope.edit = {};
    $scope.item = {};

    $scope.desc = [
        {
            name: '1',
            position: '1'
        }
    ];

    $scope.current = 1;

    $scope.getCurrent = function (position) {
        $scope.current = position;
        $scope.classificationBoxDesc = false;
        vm.ShowSelectedDesc(position - 1);
        vm.LoadLists();
    };

    $scope.addDescSimple = function () {
        lengthDesc = $scope.desc.length + 1;
        $scope.desc.push({ name: lengthDesc, position: lengthDesc });
        vm.GroupVm.DescriptionForCreationVmList.push(angular.copy(vm.NewDescriptionVm));
        $scope.getCurrent(lengthDesc);
    };

    vm.ShowSelectedDesc = function (index) {
        $scope.current = index + 1;
        vm.ActiveDescriptionVm = vm.GroupVm.DescriptionForCreationVmList[index];
    }

    $scope.indice = 0;

    $scope.nextDesc = function () {
        if ($scope.indice < $scope.client.length - 1) {
            $scope.indice++;
        }
    };
    $scope.prevDesc = function () {
        if ($scope.indice > 0) {
            $scope.indice--;
        }
    };
    
    $scope.delDesc = function (elm) {
        $scope.desc.splice(elm, 1);
        if (vm.GroupVm.DescriptionForCreationVmList.length > 1) {
            vm.GroupVm.DescriptionForCreationVmList.splice(elm, 1);
            for (var i = 0; i < $scope.desc.length; i++) {
                $scope.desc[i].name = (i + 1);
                $scope.desc[i].position = i + 1;
            }
            $scope.getCurrent(1);
        }
    };

    $scope.SelecAll = function (delectAll) {
        for (var i = 0; i < $scope.item.description[0].clients.length; i++) {
            $scope.item.description[0].clients3[i].checked = delectAll;
        }
    };

    $scope.sets = [
        {
            title: 'Arriver dans la ville',
            city: 'Paris',
            country: 'France'
        },
        {
            title: 'Se deplacer dans la ville',
            city: 'Paris',
            country: 'France'
        },
        {
            title: 'Informations pratiques',
            city: 'Paris',
            country: 'France'
        }
    ];

    $scope.toggleAll = function () {
        angular.forEach($scope.sets, function (itm) {
            console.log(itm);
            itm.selected = $scope.isAllSelected;
        });
    }

    $scope.optionToggled = function () {
        $scope.isAllSelected = $scope.sets.every(function (itm) {
            return itm.selected;
        });
    }

    $scope.newItem = angular.copy($scope.item);

    $scope.contentTranslate = null;

    $scope.item.disaplayName = $scope.item.name || ($scope.item.firstName || $scope.item.lastName);

    /**
     * Liste menu création
     */
    $scope.links = [
        {
            name: 'app.creationSet.new',
            label: 'NouveauContenu',
            state: null // edit-valid, valid
        },
        //{
        //    name: 'app.creationSet.contacts',
        //    label: 'Contacts & Droits'
        //},
        {
            name: 'app.creationSet.classification',
            label: 'classification'
        },
        {
            name: 'app.creationSet.descriptif',
            label: 'descriptif'
        }
        //{
        //    name: 'app.creationSet.objets',
        //    label: 'Objets associés'
        //},
        //{
        //    name: 'app.creationSet.visuel',
        //    label: 'Visuel'
        //},
        //{
        //    name: 'app.creationSet.sources',
        //    label: 'Sources et Commentaires'
        //}
    ];

    $scope.classificationBox = false;
    $scope.classificationBoxDesc = false;

    $scope.showOptionsBox = function (item) {
        $scope.classificationBox = true;
        $scope.itemSelected = item;
    }

    $scope.showOptionsBoxCustom = function (text, dataList) {
        $scope.classificationBox = true;
        $scope.itemSelected = {
            name: text,
            items: dataList};
    }

    $scope.showOptionsBoxDesc = function (item) {
        $scope.classificationBox = false;
        $scope.classificationBoxDesc = true;
        $scope.itemSelectedDesc = item;
    }

    vm.LoadLists = function () {
        $scope.examples = [
        {
            name: 'supportDeDiffusion',
            items: vm.GroupVm.ClientList
        },
        {
            name: 'classificationEtoile',
            items: vm.GroupVm.ParentQualificationList
        },
        // < !--[Lam Hong 25-Feb-2022] LVCG-63: LVCG-67 [BO INTERFACE] [ENCADRES CREATION] Remove some UI components -- >
        //{
        //    name: 'SousClassification',
        //    items: vm.GroupVm.QualificationList
        //},        
        // END
        {
            name: 'GuideEtoile',
            items: vm.GroupVm.AssociatedZones
        }
        ];

        $scope.classificationDesc = [
                 //{
                 //    name: 'Classifications',
                 //    items: vm.ActiveDescriptionVm.QualificationList
                 //},
                 {
                     name: 'supportDeDiffusion',
                     items: vm.ActiveDescriptionVm.Clients
                 }
        ];
    }    

    $scope.examples2 = [
        {
            name: 'Classification',
            items: [
                {
                    name: 'LV add'
                },
                {
                    name: 'LV sde'
                },
                {
                    name: 'LV app'
                },
            ]
        }
    ];

    $scope.prevStateUrl = '#';
    $scope.nextStateUrl = '#';
    $scope.currentState = 0;

    angular.forEach($scope.links, function (value, key) {
        if (value.name == $state.current.name) {
            $scope.currentState = key;
            if (key > 0) {
                $scope.prevStateUrl = $scope.links[key - 1].name != '#' ? $state.href($scope.links[key - 1].name) : '#';
            }
            if (key < $scope.links.length - 1) {
                $scope.nextStateUrl = $scope.links[key + 1].name != '#' ? $state.href($scope.links[key + 1].name) : '#';
            }
        }
    });

    $scope.setCurrentState = function (index) {

        index = (index !== 'undefined') ? index : $scope.currentState;

        $scope.currentState = index;
        $scope.prevStateUrl = $scope.links[index - 1] ? ($scope.links[index - 1].name != '#' ? $state.href($scope.links[index - 1].name) : '#') : '#';
        $scope.nextStateUrl = $scope.links[index + 1] ? ($scope.links[index + 1].name != '#' ? $state.href($scope.links[index + 1].name) : '#') : '#';

        $state.go($scope.links[index].name);

        return false;
    };

    $scope.updateState = function (direction) {
        var index = $scope.currentState;
        console.log("currentState: " + index);
        switch (direction) {
            case -1:
                if (index > 0) {
                    index = $scope.currentState - 1;
                }
                break;

            case +1:
                if (index < $scope.links.length-1) {
                    index = $scope.currentState + 1;

                }
                break;
        }
        console.log(index);
        console.log($scope.links[index].name);
        $scope.setCurrentState(index);
    }

    $scope.$on('elastic:resize', function (event, element, oldHeight, newHeight) {
        switch (element.attr("ng-model")) {
            case 'newClient.sousTitreDesc':
            case 'newItem.description[0].sousTitreDesc':
            case 'subtitleTranslate':
                element.parents('.row').find('.block-lecture .sous-titre.desc').css('height', newHeight);
                break;

            case 'newClient.txtDesc':
            case 'newItem.description[0].txtDesc':
            case 'contentTranslate':
                element.parents('.row').find('.block-lecture .text-desc').css('height', newHeight);
                break;
        }
    });
    
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
    }
    else {
        vm.ParamQcId = 10585;
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }

    $scope.useCommonCreationTopBar = true;

    initController();

    function initController() {
        GetGroupForCreation(vm.ParamQcId, $rootScope.LangForWork);
    }

    function GetGroupForCreation(qc, lang) {
        GroupService.GetGroupForCreation(qc, lang)
            .then(function (data) {
                vm.GroupVm = data;
                vm.GetAssociatedZonesOnSideBar();
                //vm.GetPlaceListOfCurrentZone();                                
                vm.ActiveDescriptionIndex = 0;
                vm.ShowSelectedDesc(vm.ActiveDescriptionIndex);
                vm.GroupVm.DescriptionForCreationVmList[0].QualificationList = angular.copy(vm.GroupVm.DescriptionQualificationList);
                vm.NewDescriptionVm = angular.copy(vm.GroupVm.DescriptionForCreationVmList[0]);
                //$scope.ChangeZoneById(vm.ParamZoneId);
                vm.LoadLists();
                $rootScope.CheckDescriptionLengthLimitForObject(qc);
            });
    }

    $scope.CreateNewObject = function CreateNewSet(redirect) {
        GroupService.CreateNewGroup(vm.GroupVm)
            .then(
               function success(data) {
                   if (redirect == true) {
                       $window.location.href = $rootScope.interfaceSubFolder + '/#!/consultation/set?id=' + data.data + '&qc=' + vm.ParamQcId + '&lang=' + $rootScope.LangForWork + '&index=0&sortKey=GroupTitle&reverse=false&z=' + vm.ParamZoneId;
                   }
                   else {
                       $window.location.href = $rootScope.interfaceSubFolder + '/#!/creation/set/new?z=' + vm.ParamZoneId + '&qc=' + vm.ParamQcId;
                       GetGroupForCreation(vm.ParamQcId, $rootScope.LangForWork);
                   }
               },
               function error(data) { 
               });            
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(0, $rootScope.EnumLinkType.Group, $rootScope.LangForWork, true, vm.ParamZoneId)
            .then(function (data) {
                vm.GroupVm.AssociatedZones = data;
                vm.LoadLists();
            });
    }

    vm.GetPlaceListOfCurrentZone = function () {
        HelperService.GetPlaceListOfCurrentZone(vm.ParamZoneId, $rootScope.LangForWork)
            .then(function (data) {
                vm.GroupVm.AssociatedPlaceOnSideBarList = data;
                vm.GroupVm.AssociatedPlaces = vm.GroupVm.AssociatedPlaceOnSideBarList;
                vm.LoadLists();
            });
    }

    //Updoad file - Start
    $scope.informations = {};
    $scope.informations.files = [];
    $scope.openExplorer = function () {
        $timeout(
            function () {
                angular.element('#newupload1').trigger('click');
            }, 0, true
        );
    };
    $scope.uploadDragNDrop = function (files) {
        for (var i = 0; i < files.length; i++) {
            var name = files[i].name;

            $scope.informations.files.push(files[i]);
        }
        $scope.$apply();
        $scope.uploadFiles();
    };

    $scope.deleteFile = function (index) {
        $scope.informations.files.splice(index, 1);
    };

    $scope.uploadFiles = function () {
        $scope.files = $scope.informations.files;

        if ($scope.files && $scope.files.length) {
            ExplorerService.UploadFilesForObject($scope.files)
            .then(function (response) {
                $timeout(function () {
                    vm.GroupVm.UploadFiles = response.data.Explorer.itemList;
                });
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                //$scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            });
        }
    };
    $scope.refreshUploadList = function (files) {
        $scope.informations.files = files;
        $scope.uploadFiles();
    }
    //Updoad file - End
}